import { graphqlRequest } from "../../services/apiService";

export const fetchUsers = async () => {
  try {
    const query = `
      query GetAllUsers {
        getAllUsers {
          id
          firstName
          lastName
          email
          phone
          role
          company
          city
          state
          zipCode
          status
          streetAddress
          address
        }
      }
    `;

    const data = await graphqlRequest(query, {});
    return data.getAllUsers;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const allUserCount = async () => {
  try {
    const query = `
      query GetUserCounts {
        getUserCounts {
          clientUsers
          managementUsers
          securityUsers
          totalUsers
          adminUsers
        }
      }
    `;

    const data = await graphqlRequest(query, {});
    return data.getUserCounts;
  } catch (error) {
    console.error("Error fetching user counts:", error);
    throw error;
  }
};
